//import { ReactComponent as HomeIcon } from 'assets/icons/Home-icon-orange.svg';
import { ReactComponent as AgendaIcon } from 'assets/icons/agenda-menu-icon.svg';
import { ReactComponent as DashIcon } from 'assets/icons/dash-menu-icon.svg';
import { ReactComponent as GeoIcon } from 'assets/icons/geo-menu-icon.svg';
import { ReactComponent as OccurIcon } from 'assets/icons/occur-menu-icon.svg';
import { ReactComponent as ActvIcon } from 'assets/icons/actv-menu-icon.svg';
import { ReactComponent as ReportsIcon } from 'assets/icons/report-menu-icon.svg';
import { ReactComponent as MaterialsIcon } from 'assets/icons/materials-menu-icon.svg';
import { ReactComponent as DocIcon } from 'assets/icons/doc-menu-icon.svg';
import { ReactComponent as RegIcon } from 'assets/icons/registry-menu-icon.svg';
import { ReactComponent as ConfigIcon } from 'assets/icons/config-menu-icon.svg';

export const iconObj = Object.fromEntries([
  //['Home', <HomeIcon />],
  ['Dashboard', <DashIcon />],
  ['Agenda', <AgendaIcon />],
  ['Ocorrências', <OccurIcon />],
  ['Atividades', <ActvIcon />],
  ['Relatórios', <ReportsIcon />],
  ['Materiais', <MaterialsIcon />],
  ['Cadastros', <RegIcon />],
  ['Documentos', <DocIcon />],
  ['Configurações', <ConfigIcon />],
  ['Geolocalização', <GeoIcon />],
]);
